import { eventBus } from '../services';

const NavCart = function (containerElement) {
  let _this = {};

  _this.classes = {
    loading: 'loading',
    empty: 'empty',
  };

  _this.init = function () {
    _this.count = containerElement.querySelector('[ws-count]');
    eventBus.on(eventBus.types.AddingToCart, _this.addingToCart);
    eventBus.on(eventBus.types.AddedToCart, _this.addedToCart);
    eventBus.on(eventBus.types.CartUpdated, _this.cartUpdated);
  };

  _this.addingToCart = function () {
    containerElement.classList.add(_this.classes.loading);
  };

  _this.addedToCart = function () {
    containerElement.classList.remove(_this.classes.loading);
  };

  _this.cartUpdated = function () {
    if (cartService.cart.item_count == 0) {
      containerElement.classList.add(_this.classes.empty);
    } else {
      containerElement.classList.remove(_this.classes.empty);
    }
  };
  return _this;
};

export default NavCart;
